export default __webpack_public_path__ + "static/media/surgical-scheduling-finish.cb6ae5aa.svg";